import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "de", "th"],
    backend: {
      loadPath: "/locales/{{lng}}/common.json",
    },
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: ["en", "de", "th"],
    lng: "th",
  });

export default i18n;
